import handleFetchErrors from '../utils/handleFetchErrors';
import { getAccessTokenFromLocalStorage } from '../utils/authHelpers';

const BASE_URL = process.env.REACT_APP_SEARCH360_HOST;

export function getSearchSuggestions() {
  return async ({
    queryKey,
  }: {
    queryKey: string[];
  }): Promise<SearchSuggestsDto> => {
    const [uri, query] = queryKey;
    const url = `${BASE_URL}${uri}?${query}`;
    return fetch(url, {
      headers: { Authorization: `Bearer ${getAccessTokenFromLocalStorage()}` },
    })
      .then(handleFetchErrors)
      .then((res) => res.json());
  };
}
